module.exports = __webpack_public_path__ + "static/wave_2-31bc1fe5b2d23eeb5f206b631072ee74.png";